import { prop } from 'fw';
import type { GoalView } from 'state/goals';
import * as d3 from "d3";

export class GoalProgressChartDeprecated {
  private readonly width: number = 900;
  private readonly height: number = 400;
  private readonly margin = {
    top: 20,
    right: 20,
    bottom: 30,
    left: 50
  };

  @prop(null) view!: GoalView;
  private chartEl: SVGElement;

  public attached() {
    this.render();
  }

  private render() {
    const width = this.width - this.margin.left - this.margin.right;
    const height = this.height - this.margin.top - this.margin.bottom;

    const svg = d3.select(this.chartEl)
      .attr("width", width + this.margin.left + this.margin.right)
      .attr("height", height + this.margin.top + this.margin.bottom);

    const scaleX = d3.scaleTime()
      .domain([new Date(this.view.definition.StartDateUtc), new Date(this.view.definition.EndDateUtc)])
      .range([10, width]);

    const scaleY = d3.scaleLinear()
      .range([height, 30]);

    // Horizontal Grid Line
    svg
      .append("g")
      .attr("transform", `translate(45, 0)`)
      .attr("class", "axis")
      .call(g => {
        g.call(
          d3.axisRight(scaleY)
            .ticks(5, "s")
            .tickSize(width - 10),
        );
        g.select(".domain").remove();
        g.attr("font-family", "");
        g
          .selectAll(".tick line")
          .attr("stroke", "#ccc")
          .attr("stroke-dasharray", "2,2");
        g
          .selectAll(".tick text")
          .attr("fill", "#ccc")
          .attr("x", "-10")
          .attr("text-anchor", "end");
      });

    // Month Axis (X)
    svg.append("g")
      .attr("transform", `translate(35, ${height})`)
      .call(g => {
        g.call(d3.axisBottom(scaleX)
          .ticks(d3.timeMonth)
          .tickFormat(d3.timeFormat("%b")));
        g.selectAll(".tick line").attr("stroke", "#999");
        g.selectAll(".tick text").attr("fill", "#999");
        g.selectAll(".domain").attr("stroke", "#999");
      });

    // Percentage Axis (Y)
    const g = svg.append("g")
      .attr("transform", `translate(45, 0)`)
      .call(g => {
        g.call(d3.axisLeft(scaleY)
          .ticks(4)
          .tickFormat(d3.format(".0%")));
        g.selectAll(".tick line").attr("stroke", "#999");
        g.selectAll(".tick text").attr("fill", "#999");
        g.selectAll(".domain").attr("stroke", "#999");
      });

    const lineHeight = ((height - 30) * (1 - ((this.view.completionPercentage > 100) ? 100 : this.view.completionPercentage) / 100)) + 30.5;

    // Percentage Line
    svg.append("line")
      .style("stroke", "#0CA7D2")
      .attr("x1", 45)
      .attr("y1", lineHeight)
      .attr("x2", width + 35)
      .attr("y2", lineHeight);

    // Percentage Text
    svg.append("text")
      .attr("x", width + 39)
      .attr("y", lineHeight)
      .attr("dy", ".35em")
      .style("font-size", ".85em")
      .text(`${this.view.completionPercentage}%`);

    // Diagonal Dashed line (bottom left -> top right)
    svg.append("line")
      .style("stroke", "green")
      .style("stroke-dasharray", ("5, 5"))
      .attr("x1", width + 35.5)
      .attr("y1", 31)
      .attr("x2", 46)
      .attr("y2", height);

    // Right-hand side dashed line
    svg.append("line")
      .style("stroke", "#ccc")
      .style("stroke-dasharray", ("2, 2"))
      .attr("x1", width + 35.5)
      .attr("y1", 30.5)
      .attr("x2", width + 35.5)
      .attr("y2", height);

    // Today vertical line
    const today = new Date();
    const todayLineX = scaleX(today) + 34.5;
    if (todayLineX < 870 && todayLineX > 30) {
      svg.append("line")
        .attr("x1", todayLineX)
        .attr("y1", 30.5)
        .attr("x2", todayLineX)
        .attr("y2", height)
        .style("stroke-width", 1)
        .style("stroke", "#0CA7D2")
        .style("fill", "none");

      svg.append("text")
        .attr("x", todayLineX - 17.5)
        .attr("y", 15.5)
        .attr("dy", ".35em")
        .style("font-size", ".85em")
        .text('Today');
    }
  }
}
